/* eslint-disable jsx-a11y/label-has-for, jsx-a11y/label-has-associated-control */
import { React, PT, fetchApi } from '@gasbuddy/react';
import JSONTree from 'react-json-tree';
import moment from 'moment';
import { Modal, Button, Dimmer, Loader } from 'semantic-ui-react';

export class StripeDeclinesModal extends React.Component {
  state = {}

  loadAndGo = () => {
    const { accountId, afterDate } = this.props;
    this.setState({ opened: true, loading: true }, async () => {
      const { body } = await fetchApi({
        url: '/payments/stripe-declines',
        body: {
          account_id: accountId,
          after: afterDate,
        },
      });
      this.setState({ loading: false, body, afterDate });
    });
  }

  render() {
    const { opened, loading, body, afterDate } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button floated="right" size="mini" onClick={this.loadAndGo}>Stripe Declines</Button>}
      >
        <Modal.Header>
          Stripe Declines From
          {' '}
          {moment(afterDate).format('MMM Do YYYY')}
        </Modal.Header>
        <Modal.Content>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <JSONTree data={body} shouldExpandNode={(k, d, l) => l <= 1} />
            </div>
          </Dimmer.Dimmable>
        </Modal.Content>
        <Modal.Actions>
          <Button
            basic
            onClick={() => {
              const newDate = moment(afterDate).subtract(7, 'days');
              this.props.afterDate = newDate;
              this.setState({ afterDate: newDate });
              this.loadAndGo();
            }
         }>
            Previous Week (From
            {' '}
            {moment(afterDate).subtract(7, 'days').format('MMM Do YYYY')}
            )
          </Button>
          <Button
            basic
            onClick={() => {
              const newDate = moment(afterDate).add(7, 'days');
              this.props.afterDate = newDate;
              this.setState({ afterDate: newDate });
              this.loadAndGo();
            }
         }>
            Next Week (From
            {' '}
            {moment(afterDate).add(7, 'days').format('MMM Do YYYY')}
            )
          </Button>
          <Button basic onClick={() => this.setState({ opened: false, body: null })}>
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

StripeDeclinesModal.propTypes = {
  accountId: PT.number,
  afterDate: PT.number,
};

StripeDeclinesModal.defaultProps = {
  accountId: 0,
  afterDate: moment().subtract(7, 'days'),
};
